export default "/images/icon-ai-image.gif?ad34b2db7e8d16b39a5de5c4999bb631";